"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroupSmall = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FieldLayout = require("./layout/FieldLayout");

var _InputInnerWrap = require("./InputInnerWrap");

var _FieldLabel = require("./microFields/FieldLabel");

var _FieldHelper = require("./microFields/FieldHelper");

var _FieldValidationMessage = require("./microFields/FieldValidationMessage");

var _fieldUtils = require("./microFields/fieldUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputGroupSmall = function InputGroupSmall(_ref) {
  var fieldName = _ref.fieldName,
      value = _ref.value,
      atts = _ref.atts,
      label = _ref.label,
      helper = _ref.helper,
      children = _ref.children,
      cashbotName = _ref.cashbotName,
      isInvalid = _ref.isInvalid,
      isTouched = _ref.isTouched,
      errorMessage = _ref.errorMessage,
      warningMessage = _ref.warningMessage,
      isRequiredField = _ref.isRequiredField,
      wrappedElement = _ref.wrappedElement,
      doFocus = _ref.doFocus,
      hiddenLabel = _ref.hiddenLabel,
      hiddenHelper = _ref.hiddenHelper,
      showValidationErrors = _ref.showValidationErrors;
  var fieldIds = (0, _fieldUtils.getAllFieldElementIds)(fieldName);
  var validationProps = (0, _fieldUtils.getValidationProps)(value, isInvalid, isTouched, warningMessage, errorMessage);
  var showInvalid = validationProps.isInvalid;
  var labelAttrs = {
    fieldName: fieldName,
    label: label,
    isInvalid: showInvalid,
    isHidden: hiddenLabel
  };
  var helperProps = {
    id: fieldIds.helper.id,
    isHidden: hiddenHelper,
    helper: helper,
    isInvalid: showInvalid // to style the helper above the field (specific to this layout)

  };
  var inputInnerProps = {
    fieldName: fieldName,
    atts: atts,
    label: label,
    helper: helper,
    isRequiredField: isRequiredField,
    isInvalid: showInvalid,
    showCounter: false,
    validationProps: validationProps,
    wrappedElement: wrappedElement,
    doFocus: doFocus,
    hiddenLabel: hiddenLabel
  };
  var validationMsgProps = {
    id: fieldIds.validation.id,
    fieldName: fieldName,
    validationProps: validationProps
  };
  return _react.default.createElement(_FieldLayout.FieldWrapper, {
    fieldName: fieldName,
    cashbotName: cashbotName,
    isSmall: true
  }, _react.default.createElement(_FieldLabel.FieldLabel, labelAttrs), _react.default.createElement(_FieldHelper.FieldHelper, helperProps), children || _react.default.createElement(_InputInnerWrap.InputInnerWrap, inputInnerProps), showValidationErrors && _react.default.createElement(_FieldValidationMessage.FieldValidationMessage, validationMsgProps));
};

exports.InputGroupSmall = InputGroupSmall;
InputGroupSmall.defaultProps = {
  children: null,
  isInvalid: false,
  isTouched: false,
  warningMessage: null,
  errorMessage: null,
  isRequiredField: true,
  wrappedElement: null,
  doFocus: false,
  hiddenLabel: false,
  hiddenHelper: false,
  showValidationErrors: false
};
InputGroupSmall.propTypes = {
  fieldName: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  atts: _propTypes.default.shape({
    type: _propTypes.default.oneOf(['email', 'tel', 'text'])
  }).isRequired,
  label: _propTypes.default.string.isRequired,
  children: _propTypes.default.node,
  helper: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  isInvalid: _propTypes.default.bool,
  isTouched: _propTypes.default.bool,
  warningMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  errorMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  isRequiredField: _propTypes.default.bool,
  wrappedElement: _propTypes.default.node,
  doFocus: _propTypes.default.bool,
  hiddenLabel: _propTypes.default.bool,
  hiddenHelper: _propTypes.default.bool,
  showValidationErrors: _propTypes.default.bool
};